import IMA from './ima/adsPlayer';
import { adsSelector } from '@shared/store/slices/ads.slice';
import { useAppSelector } from '@shared/store/hooks';

export default function AdsSelector() {
  const { source } = useAppSelector(adsSelector);
  return source ? <IMA source={source} /> : null;
}
